$('body').on('click', '[data-analytics][data-click]', function(e) {
	var date = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
	var cat = $(this).data('cat');
	var action = $(this).data('action');
	var name = $(this).data('name');
	var user_info = window.user_info;

	var sessionId = Cookies.get('session_id');
	var clientId;

	ga(function(tracker) {
	  clientId = tracker.get('clientId');
	});

	if (user_info) ga('set', 'dimension1', user_info);
	ga('set', 'dimension2', date);
	ga('set', 'dimension3', clientId);
	ga('set', 'dimension4', sessionId);
	ga('send', 'event', cat, action, name);
});

$( document ).ready(function() {
    addGACustomDimensions();
});

function addGACustomDimensions() {
    ga('set', 'dimension2', 'notSet');
    ga('set', 'dimension2', createTimeStamp());
    ga('set', 'dimension3', createClientID());
    ga('set', 'dimension4', createSessionID());
}

function createTimeStamp() {
    var now = new Date();
    var pad = function (value) {
        return ("0" + value).slice(-2)
    };
    return now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate()) + ' ' + pad(now.getHours()) + ':' + pad(now.getMinutes()) + ':' + pad(now.getSeconds());
}

function createClientID() {
    var gaClientId;
    ga(function(tracker) {
	  gaClientId = tracker.get('clientId');
	});
    if (gaClientId == 'notSet') {
        try {
            var trackers = ga.getAll();
            gaClientId = trackers[0].get('clientId');
            return gaClientId;
        }
        catch (ex) {
            // GA probably blocked by user.
        }
    }
    return gaClientId;
}

function createSessionID() {
    var sessionId = getCookie("sessionId")
    if (sessionId == undefined) {
        sessionId = new Date().getTime() + '.' + Math.random().toString(36).substring(5);
        setCookie("sessionId", sessionId);
    }
    return sessionId;
}

function setCookie(name, value) {
    Cookies.set(name, value);
}

function getCookie(name) {
    return Cookies.get(name);
}
